import { Component, OnInit, Inject,PLATFORM_ID } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { WishlistService } from '../../shared/services/wishlist.service';
import { RootService } from 'src/app/shared/services/root.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-popular-vehicle',
  templateUrl: './popular-vehicle.component.html',
  styleUrls: ['./popular-vehicle.component.scss']
})
export class PopularVehicleComponent implements OnInit {
  popularVehicleList: any;
  environment1 = environment.s3bucket.url;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };
  slideConfig = {
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    dots: true,
    autoplay: true,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
  };
  isUserLoggedIn: boolean;
  userData: any;
  constructor(private ApiService: ApiService,
    private WishlistService: WishlistService, private rootService: RootService,
    private toastrService: ToastrService,
    private router: Router, public skeletonService: SkeletonService,
    private behaviorService: BehaviourSubjectService,@Inject(PLATFORM_ID) private platformId: Object,private cleverService: ClevertapService) { }
  sub: Subscription = new Subscription();

  showLoader: any = false;
  productLoaded: boolean = false;

  ngOnInit(): void {
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      this.userData = this.rootService.getUserData();
    }));
    this.getPopularVehicle()
  }
  customOptions1: OwlOptions = {
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
   ],
    responsive: {
      0: {
        items: 1.3
      },
      400: {
        items: 2
      },
      600: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }

  getPopularVehicle() {
    let data = {
      "start_row": 0,
      "end_row": 15,
      "is_new_launch": true,
    }
    this.showLoader = true;
    try {
      this.sub.add(this.ApiService.getVehicleInfo2(data).subscribe(
        (res) => {
          this.showLoader = false;
          this.productLoaded = true;
          if (res.success) {
            this.popularVehicleList = res.data
            if (!this.rootService.getUserData()) {
              let wishList: any = [];
              wishList = this.WishlistService.getWishlist();
              if (wishList?.length > 0) {
                wishList.forEach((el: any) => {
                  for (let i = 0; i < this.popularVehicleList?.length; i++) {
                    if (el == this.popularVehicleList[i].id) {
                      this.popularVehicleList[i].wishlist = true
                    }
                  }
                })
              }
            }
            for (let i = 0; i < this.popularVehicleList?.length; i++) {
              this.popularVehicleList[i].imgData = []
              if (this.popularVehicleList[i].images?.length > 5) {
                for (var j = 0; j < 5; j++) {
                  this.popularVehicleList[i].imgData.push(this.popularVehicleList[i].images[j])
                }
              }
              else {
                this.popularVehicleList[i].imgData = this.popularVehicleList[i].images
              }
            }
          }
        },
        () => {
          this.productLoaded = true;
        }
      ))
    } catch (error) {
      this.productLoaded = true;
    }

  }

  clickToAddWishlist(event: any) {

    if (this.rootService.getUserData()) {
      let index: any
      for (let e = 0; e < this.popularVehicleList?.length; e++) {
        if (this.popularVehicleList[e].id == event) {
          index = this.popularVehicleList.findIndex((e: any) => e.id == event)
        }
      }
      if (this.popularVehicleList[index].id == event) {
        if (this.popularVehicleList[index].wishlist == false) {
          this.popularVehicleList[index].wishlist = true
          this.addToWishlist(event,'add')
          return
        }
        if (this.popularVehicleList[index].wishlist == true) {
          this.popularVehicleList[index].wishlist = false
          this.addToWishlist(event,'delete')
          return
        }
      }
    }
    else {
      this.popularVehicleList.forEach((e: any) => {
        if (e.id == event)
          e.wishlist = !e.wishlist
      })

      this.WishlistService.addItemToWishList(event)
      let wishList: any = [];
      wishList = this.WishlistService.getWishlist();
      wishList?.forEach((el: any) => {
        for (let i = 0; i < this.popularVehicleList?.length; i++) {
          if (el == this.popularVehicleList[i].id) {
            this.popularVehicleList.wishlist = true
          }
          else {
            this.popularVehicleList.wishlist = false
          }
        }
      })
    }
  }

  addToWishlist(event: any,type:any) {
    let data;
    if(type == 'add'){

     data = {
      "product": [event],
      action_type: "add"
    }
  }else{
    data = {
      "action_type": "delete",
      "product_list": [event]
    }
  }
    try {
      this.sub.add(this.ApiService.addToWishlist(data).subscribe({
        next: (res: any) => {
    if(type == 'add'){

          this.toastrService.success(res.data.msg)
          this.popularVehicleList.forEach((e: any) => {
            if (e.id == event) {
              e.wishlist = true
              return
            }
          })
        }else{
          this.toastrService.warning(res.data.msg)

        }
        },
        error: () => { },
        complete: () => { }
      }))
    } catch (error) {
    }

  }



  openProduct(data: any) {
    let sublob = (data.sub_lob == 'SCV Pickups' ? 'scv-pickups' : data.sub_lob == 'Icv Trucks' ? 'trucks' : 'buses-vans')?.toLowerCase();
    let lob = data.lob.replace(/\s/g, "-")?.toLowerCase();;
    let ppl = data.ppl_seo;
    let pl = data.pl.replace(/\s/g, "-")?.toLowerCase();
    var url = '/product-details/' + sublob + '/' + lob + '/' + ppl + '/' + pl + '/' + data.id;
    return url;

  }

  bookNow(data) {
    if (this.isUserLoggedIn) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    this.router.navigate(['/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);
    }
    else {
      let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id)
      this.router.navigate(['/login/']);
    }
    this.clevertapBook(data);
  }

  clevertapBook(productDetailsData: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(productDetailsData["id"],
          productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation");
      }
      catch { }
    }

  }
  ngOnDestroy() {
    this.sub.unsubscribe()
  }
}
